import React from 'react';
import { Switch, Collapse } from '@mui/material';

class AutoMappingRecipeGroup extends React.PureComponent {
  render() {
    const { data, isReadOnly, isExpanded } = this.props;

    return (
      <Collapse in={isExpanded}>
        <div className="auto-mapping-recipe-group">
          Send all data through without transformations
          {isReadOnly ? (
            <span className="auto-mapping-status">ON</span>
          ) : (
            <Switch checked={data} disableRipple onChange={this._handleSwitchChanged} />
          )}
        </div>
      </Collapse>
    );
  }

  _handleSwitchChanged = (e, isChecked) => {
    this.props.onChangeRecipeGroup(isChecked);
  };
}

export default AutoMappingRecipeGroup;
